var __WEBPACK_NAMESPACE_OBJECT__ = dependencies['lodash']['4']['module'];